<app-hero-courses></app-hero-courses>
<!-- <div class="first container grid">
  <div class="row my-4">
    <div class="col-xl d-flex justify-content-center align-items-center my-3">
      <img src="../../../../assets/img/educatori.png" alt="" />
    </div>
    <div class="col-xl d-flex justify-content-center align-items-center mt-5">
      <img src="../../../../assets/img/12moduli.png" alt="" />
    </div>
  </div>
</div> -->

<div class="second container grid">
  <h3 class="w-700 blue-50 text-center px-1">
    La programmazione a portata di tutti.
  </h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    Con Scratch si possono
    <span class="underline-a"
      >creare cartoni animati, animazioni, storie interattive,</span
    >
    quiz e puzzle, ma anche dei semplici giochi arcade.
  </p>
  <p class="w-500 neutral-100 pt-4 px-2 px-xl-5">
    <span class="underline-b"
      >È adatto a chi non ha conoscenze di base della programmazione </span
    >, aiuta a sviluppare competenze logiche, a ragionare in modo sistematico e
    a risolvere problemi in modo creativo ed efficiente attraverso il
    <span class="underline-p">lavoro di squadra</span>.
  </p>
</div>

<div class="third container grid">
  <h3 class="w-700 blue-50 text-center">Utilizza un linguaggio a blocchi.</h3>
  <p class="w-500 neutral-100 px-2 px-xl-5">
    È un ambiente di programmazione gratuito con un linguaggio di programmazione
    a blocchi. Si ispira alla teoria costruzionista dell’apprendimento ed è
    pensato per l’insegnamento della programmazione, per progetti pedagogici e
    di intrattenimento che spaziano dalla matematica alla scienza, consentendo
    la realizzazione di simulazioni, visualizzazione di esperimenti, animazioni,
    musica, arte interattiva e semplici giochi.
  </p>
  <div class="d-flex justify-content-center align-items-center">
    <img
      src="../../../../assets/img/cats.png"
      alt="Gatti Scratch"
     
      class="cats"
    />
  </div>
</div>

<div class="fourth container grid">
  <div class="d-flex justify-content-center">
    <img
      src="../../../../assets/img/scracth-screen.jpg"
      alt="Interfaccia Scratch"
     
      class="scracth-screen px-2 px-xl-0"
    />
  </div>
</div>

<div class="fifth container grid"></div>
<app-modules [data]="modulesText"></app-modules>
<app-iscriviti></app-iscriviti>
